import meta from './meta';
import ui from './ui';
import display from './display';
import indicator from './indicator';
import breakdown from './breakdown';

export default {
  modules: {
    meta,
    ui,
    display,
    indicator,
    breakdown,
  },
};
